<p-toast></p-toast>
<div class="table-responsive text-center justify-content-center"
    style="font-size:14px; margin-bottom: 20px;text-align: center;vertical-align: center;">
    <p-table [value]="refundList" [lazy]="true" (onLazyLoad)="fetchAll($event)" [paginator]="true"
        [rows]="pagination.records_per_page" [totalRecords]="total_records" [loading]="loading"
        [globalFilterFields]="[]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[10,25,50]" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="sr_no" style="width: 70px;"><b>Sr No</b></th>
                
                <th pSortableColumn="refund_type"><b>Refund Type</b></th>
                
                <th pSortableColumn="refund_amount"><b>Actual Amount before discounts</b></th>
                
                <th pSortableColumn="refund_amount"><b>Paid Amount</b></th>
                
                <th pSortableColumn="refund_amount"><b>Refund Amount</b></th>
                
                <th pSortableColumn="audited_by_user_name"><b>Audited by</b></th>
                
                <th pSortableColumn="created_at"><b>Requested at</b></th>
                
                <th pSortableColumn="status"><b>Refund Status</b></th>
                
                <th><b>Full Details</b></th>
                
                <th><b>Action</b></th>
                
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-refund>
            <tr>
                <td style="width: 70px;">{{refund.sr_no}}</td>
                <td>{{refund.refund_type}}</td>
                <td>{{refund.refund_actual_amount}}</td>
                <td>{{refund.refund_discounted_amount}}</td>
                <td>{{refund.refund_amount}}</td>
                <td>{{refund.audited_by_user_name}}</td>
                <td>{{refund.created_at | date: 'medium'}}</td>
                <td>{{refund.refund_status}}</td>
                <td><button pButton pRipple type="button" icon="pi pi-external-link" label="Info" class="p-button-info"
                        (click)="fetch(refund.refund_id)"></button></td>
                <td>
                    <button *ngIf="refund.refund_status=='IN PROGRESS'" pButton pRipple type="button"
                        icon="pi pi-external-link" label="Approve/Decline" class="p-button-warning"
                        (click)="sanctionDialogAction(refund.refund_id)"></button>
                    <p *ngIf="refund.refund_status!='IN PROGRESS'">N/A</p>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog header="Refund information" *ngIf="details_dialog_bool" [(visible)]="details_dialog_bool"
    (onHide)="details_dialog_bool=false" [style]="{width: '50vw'}">
    <p-accordion [multiple]="true">
        <p-accordionTab header="Basic Information">
            <p><b>Transaction Type</b>: {{refD.data.refund_type}}</p>
            <p><b>Refund Amount</b>: {{refD.refund_amount}}</p>
            <p><b>Transaction Amount</b>: {{refD.transaction_amount}}</p>
            <p><b>Reason for Refund</b>: {{refD.data.p_cancellations.reason}}</p>
            <p><b>Refund Request Raised at</b>: {{refD.data.created_at | date: 'medium'}}</p>
            <p><b>Refund Status</b>: {{refD.data.refund_status.status}}</p>
        </p-accordionTab>
        <p-accordionTab header="Audit Information">
            <p><b>Audited by</b>: {{refD.data.audited_by_user_name || 'N/A'}}</p>
            <p><b>Audited at</b>: {{refD.data.audited_at || 'N/A'}}</p>
        </p-accordionTab>
        <p-accordionTab header="Requester Information">
            <p><b>Refund Request Raised at</b>: {{refD.data.created_at}}</p>
            <p *ngIf="refD.data.p_cancellations.refund_audit.p_accounts!=null"><b>Request Raised by (Patient)</b>:
                {{refD.data.p_cancellations.refund_audit.p_accounts.first_name+"
                "+(refD.data.p_cancellations.refund_audit.p_accounts.middle_name || '')+" "
                +refD.data.p_cancellations.refund_audit.p_accounts.last_name
                +"("+refD.data.p_cancellations.refund_audit.p_accounts.medical_record_number+")"}}
            </p>
            <p *ngIf="refD.data.p_cancellations.refund_audit.egd_users!=null"><b>Request Raised by (eGlobal User)</b>:
                {{refD.data.p_cancellations.refund_audit.egd_users.first_name+"
                "+(refD.data.p_cancellations.refund_audit.egd_users.middle_name || '')+" "
                +refD.data.p_cancellations.refund_audit.egd_users.last_name}}

            </p>
        </p-accordionTab>
        <p-accordionTab header="Transaction Information">
            <p><b>Transaction Type</b>: {{refD.data.refund_type}}</p>
            <p><b>Transaction Date: </b>:
                {{refD.data.p_cancellations.p_transactions.created_at | date: 'medium'}}</p>
            <p><b>Transaction Number</b>: {{refD.data.p_cancellations.p_transactions.transaction_no}}</p>
            <p><b>Patient Details</b>:
                {{refD.data.p_cancellations.p_transactions.p_accounts.first_name+"
                "+(refD.data.p_cancellations.p_transactions.p_accounts.middle_name || '')+" "
                +refD.data.p_cancellations.p_transactions.p_accounts.last_name
                +"("+refD.data.p_cancellations.p_transactions.p_accounts.medical_record_number+")"}}
            </p>
            <p *ngIf="refD.data.p_cancellations.p_transactions.p_consultation!=null"><b>Consultation Request Number</b>:
                {{refD.data.p_cancellations.p_transactions.p_consultation.consultation_request_number}}</p>
        </p-accordionTab>
        <p-accordionTab header="Payment Gateway Information">
            <p><b>Payment Gateway</b>: {{refD.data.p_cancellations.p_transactions.payment_gateway_type}}</p>
            <div *ngIf="refD.data.p_cancellations.p_transactions.payment_gateway_type=='paypal'">
                <p><b>Paypal Transaction ID</b>:
                    {{refD.data.p_cancellations.p_transactions.paypal.paypal_transaction_id}}</p>
                <p><b>Paypal Refund Transaction ID</b>: {{refD.data.paypal_refund?.paypal_transaction_id || 'N/A'}}</p>
            </div>
            <div *ngIf="refD.data.p_cancellations.p_transactions.payment_gateway_type=='razorpay'">
                <p><b>Razorpay Payment ID</b>: {{refD.data.p_cancellations.p_transactions.razor_pay.payment_id}}</p>
                <p><b>Razorpay Refund ID</b>: {{refD.data.razorpay_refund?.razorpay_refund_transaction_id || 'N/A'}}</p>
            </div>

        </p-accordionTab>
    </p-accordion>


</p-dialog>

<p-dialog header="Approve/Decline a refund" *ngIf="sanction_dialog_bool" [(visible)]="sanction_dialog_bool"
    (onHide)="sanctionDialogAction(null)" [style]="{width: '50vw'}">
    <form accept-charset="UTF-8" #sanctionForm="ngForm" (ngSubmit)="sanction(sanction_body)">
        <div class="ui-g">
            <h4>Approve?</h4>

            <div class="ui-g-12 ui-md-4" style="width:30%">
                <p-radioButton name="approval" #approval="ngModel" [value]="true" [(ngModel)]="sanction_body.approve"
                    required></p-radioButton>
                <label for="approve"> Yes</label>
            </div>
            <div class="ui-g-12 ui-md-4" style="width:30%">
                <p-radioButton name="approval" #approval="ngModel" [value]="false" [(ngModel)]="sanction_body.approve"
                    required></p-radioButton>
                <label for="reject"> No</label>
            </div>


            <div *ngIf="(approval.invalid && (approval.dirty || approval.touched))" class="alert alert-danger">
                <div *ngIf="approval.errors.required" class="invalid">
                    This refund needs to either be approved or rejected.
                </div>
            </div>

        </div>


        <br>

        <br>
        <button type="submit" pButton label="Submit" icon="pi pi-check"
            [disabled]="!sanctionForm.valid || loading"></button>

        <p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="loading" strokeWidth="6">
        </p-progressSpinner>
        <div class="row container justify-content-center text-center alert alert-danger"
            *ngIf="response.success!=null && response.success==false">
            <p *ngIf="response.error!=null">{{response.error.message}}</p>
            <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
                <p *ngFor="let message of serverError?.message">{{message}}</p>
            </div>
            <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
                <p>{{serverError?.message}}</p>
            </div>

        </div>
    </form>

</p-dialog>